<template>
  <div id="app">
    <AppNavigation/>
    <LoadingScreen/>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import LoadingScreen from './components/loading/LoadingScreen';

export default {
  components: {
    LoadingScreen,
  },
  created() {
    this.$store.dispatch('init');
  },
};
</script>

<style src="./styles/main.scss" lang="scss" />
